<template>
  <div>
    <header class="header_in clearfix">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-xl-4 noMobile" style="line-height: 50px;">
            <div id="logo">
              <a href="/" class="home">
                <!-- <i class="mdi mdi-home-variant h5"></i>  -->
                <i class="fas fa-home"></i>
                Home
              </a>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-xl-4 align-center">
            <div id="mainLogo logo">
              <a href="/">
                <img class="mainLogoImg" src="../../templateAssests/img/cklogo.png" width="121" height="55" alt="">
              </a>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-xl-4 align-right rightDiv noMobile" style="margin-top:10px;">
            <!-- <a href="/">
              <i class="mdi mdi-help h5"></i>
                             Help
            </a> -->
            <a href="tel:+917710999666" class="phneNo">
              <i class="mdi mdi-phone h5"></i>+91 771 099 9666
            </a>
            <br>
            <a href="mailto:enquiry@cloudkitch.co.in" class="email">
              <i class="far fa-envelope"></i>enquiry@cloudkitch.co.in
            </a>
          </div>
          <!-- /top_menu -->
          <a href="#0" class="open_close">
            <i @click="toggleMenuDrawer" class="icon_menu"></i>
            <Drawer @close="toggleMenuDrawer" align="left" :maskClosable="true" :closeable="false">
              <div v-if="openMenuDrawer">
                <section class="head_section">
                  <div v-if="userName != ''" class="row">
                    <div class="align-left">
                      <!-- <figure> -->
                      <img class="userPlaceImage" src="https://assets.cloudkitch.co.in/user_documents/avatar.jpg"
                           height="50" width="50" alt="">
                      <!-- </figure> -->
                    </div>
                    <div class="align-left">
                      <a href="/profile/my-profile" class="userName"
                         style="margin:8px 0 0 0; color:#212121; font-size:14px;">{{ userName }}</a>
                      <!-- <p class="userName userNameTextLen one-line-text" style="margin:8px 0 0 0;">{{userName}}</p> -->
                    </div>
                  </div>
                  <div v-else class="row">
                    <div class="align-left">
                      <p class="loginReg" @click="openLoginModal">Login / Register</p>
                    </div>
                  </div>
                </section>
                <hr style="margin:0px;">
                <section class="navigation_section">
                  <ul class="dropdown-ul navigation_ul align-left">
                    <a href="/">
                      <li><img src="../../templateAssests/img/ckgallery/CloudKitch_logo_solo.png"
                               style="object-fit:contain;margin-right:10px;" width="25" height="25" alt="">Home
                      </li>
                    </a>
                    <a @click="userRedirection('/checkOut')">
                      <li><img src="../../templateAssests/img/ckgallery/Cart.png" width="25" height="25"
                               style="object-fit:contain;margin-right:10px;" alt="">Cart
                      </li>
                    </a>
                    <a @click="userRedirection('/profile/my-orders')">
                      <li><i class="icon_bag_alt" style="font-size:20px;margin-right:10px;"></i>My Orders</li>
                    </a>
                    <a @click="userRedirection('/profile/my-subscriptions')">
                      <li><i class="mdi mdi-calendar-clock" style="font-size:20px;margin-right:10px;"></i>My
                        Subscriptions
                      </li>
                    </a>
                    <a @click="userRedirection('/profile/my-vouchers')">
                      <li><i class="mdi mdi-ticket-percent-outline" style="font-size:20px;margin-right:10px;"></i>Pre-Buy
                        Vouchers
                      </li>
                    </a>
                    <a @click="userRedirection('/profile/my-address')">
                      <li><i class="far fa-address-book" style="font-size:20px;margin-right:10px;"></i>My Address</li>
                    </a>
                    <a @click="userRedirection('/profile/wallet')">
                      <li><i class="mdi mdi-wallet-outline" style="font-size:20px;margin-right:10px;"></i>Wallet</li>
                    </a>
                  </ul>
                </section>
                <hr class="hrBorder">
                <!-- navigation_section -->

                <section class="help_section">
                  <h3 class="helpHead align-left">Help & Support</h3>
                  <ul class="dropdown-ul navigation_ul align-left">
                    <a href="/terms-and-conditions"><li><i class="mdi mdi-file-document-multiple-outline" style="font-size:20px;margin-right:10px;"></i>Terms & Conditions</li></a>
                    <a href="/data-privacy"><li><i class="mdi mdi-file-document-outline" style="font-size:20px;margin-right:10px;"></i>Data Privacy</li></a>
                    <!--														<a href="/policies/cookie-policy"><li><i class="mdi mdi-cookie-outline" style="font-size:20px;margin-right:10px;"></i>Cookie Policy</li></a>-->
                    <a href="/cancellations-and-refunds"><li><i class="mdi mdi-cash-refund" style="font-size:20px;margin-right:10px;"></i>Cancellations & Refunds</li></a>
                    <a href="#">
                      <li><i class="icon_mail_alt" style="font-size:20px;margin-right:10px;"></i>Contact Us</li>
                    </a>
                  </ul>
                </section>
                <hr class="hrBorder">
                <!-- help_section -->

                <section class="other_section" v-if="userName != ''">
                  <h3 class="helpHead align-left">Other</h3>
                  <ul class="dropdown-ul navigation_ul align-left">
                    <li><a @click="logout"><i class="uil uil-sign-out-alt"
                                              style="font-size:20px;margin-right:10px;"></i>Logout</a></li>
                  </ul>
                </section>
                <!-- <hr class="hrBorder"> -->
                <!-- navigation_section -->

              </div>
            </Drawer>
          </a>
        </div>
        <!-- / row -->
      </div>
      <!-- / container -->


    </header>
    <!-- /header -->
    <main>
      <div class="container">
          <b-card-text>
            <div class="section-services container">
              <h2 class="setionTitle align-center">Terms &amp; Conditions</h2>
              <p>This document is an electronic record in terms of Information Technology Act, 2000 and rules there
                under as applicable and the amended provisions pertaining to electronic records in various statutes as
                amended by the Information Technology Act, 2000. This document is published in accordance with the
                provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that
                require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of <a
                    href="http://cloudkitch.co.in/" target="_blank">www.cloudkitch.co.in</a>
                website and CLOUDKITCH application for mobile and handheld devices.</p>
              <h2 class="policyHead">Terms Of Use</h2>
              <ul>
                <li>
                  <p>These terms of use (the " Terms of Use") govern your use of our website www.cloudkitch.co.in (the "
                    Website") and our "CLOUDKITCH" application for mobile and handheld devices (the " App"). The Website
                    and the App are jointly referred to as the " Platform". Please read these Terms of Use carefully
                    before you use the services. If you do not agree to these Terms of Use, you may not use the services
                    on the Platform, and we request you to uninstall the App. By installing, downloading or even merely
                    using the Platform, you shall be contracting with CLOUDKITCH and you signify your acceptance to the
                    Terms of Use and other CLOUDKITCH policies (including but not limited to the Cancellation & Refund
                    Policy, Privacy Policy and Take Down Policy) as posted on the Platform from time to time, which
                    takes effect on the date on which you download, install or use the Services, and create a legally
                    binding arrangement to abide by the same.</p></li>
                <li>
                  <p>
                    The Platform is operated and owned by CLOUD KITCH Private Limited, a company incorporated under the
                    Companies Act, 1956 and having its registered office at 1403, Tower 3, Indiabulls Finance Centre,
                    Senapati Bapat Marg, Elphinestone Road, Mumbai, Maharashtra, Mumbai- 400013. For the purpose of
                    these Terms of Use, wherever the context so requires, "you" shall mean any natural or legal person
                    who has agreed to become a buyer or customer on the Platform by providing Registration Data while
                    registering on the Platform as a registered user using any computer systems. The terms "CLOUDKITCH",
                    "we", "us" or "our" shall mean CLOUD KITCH Private Limited.
                  </p></li>
                <li>
                  <p>
                    CLOUDKITCH enables transactions between participant restaurants/merchants and buyers, dealing in
                    prepared food and beverages (" Platform Services"). The buyers (" Buyer/s") can choose and place
                    orders (" Orders") from variety of products listed and offered for sale by various neighbourhood
                    merchants including but not limited to the restaurants and eateries (" Merchant/s"), on the Platform
                    and CLOUDKITCH enables delivery of such orders at select localities of serviceable cities across
                    India (" Delivery Services"). The Platform Services and Delivery Services are collectively referred
                    to as " Services".
                  </p></li>
              </ul>
              <h4>AMENDMENTS</h4>
              <ul>
                <li>
                  <p>
                    These Terms of Use are subject to modifications at any time. We reserve the right to modify or
                    change these Terms of Use and other CLOUDKITCH policies at any time by posting changes on the
                    Platform, and you shall be liable to update yourself of such changes, if any, by accessing the
                    changes on the Platform. You shall, at all times, be responsible for regularly reviewing the Terms
                    of Use and the other CLOUDKITCH policies and note the changes made on the Platform. Your continued
                    usage of the services after any change is posted constitutes your acceptance of the amended Terms of
                    Use and other CLOUDKITCH policies. As long as you comply with these Terms of Use, CLOUDKITCH grants
                    you a personal, non-exclusive, non-transferable, limited privilege to access, enter, and use the
                    Platform. By accepting these Terms of Use, you also accept and agree to be bound by the other terms
                    and conditions and CLOUDKITCH policies (including but not limited to Cancellation & Refund Policy,
                    Privacy Policy and Notice and Take Down Policy) as may be posted on the Platform from time to time.
                  </p>
                </li>
              </ul>
              <h4>Use of Platform and Services</h4>
              <ul>
                <li>
                  <p>
                    All commercial/contractual terms are offered by and agreed to between Buyers and Merchants alone.
                    The commercial/contractual terms include without limitation price, taxes, shipping costs, payment
                    methods, payment terms, date, period and mode of delivery, warranties related to products and
                    services and after sales services related to products and services. CLOUDKITCH does not have any
                    control or does not determine or advise or in any way involve itself in the offering or acceptance
                    of such commercial/contractual terms between the Buyers and Merchants. CLOUDKITCH may, however,
                    offer support services to Merchants in respect to order fulfilment, payment collection, call centre,
                    and other services, pursuant to independent contracts executed by it with the Merchants.
                  </p>
                </li>
                <li>
                  <p>
                    CLOUDKITCH does not make any representation or warranty as to the item-specifics (such as legal
                    title, creditworthiness, identity, etc.) of any of the Merchants. You are advised to independently
                    verify the bona fides of any particular Merchant that you choose to deal with on the Platform and
                    use your best judgment in that behalf. All Merchant offers and third party offers are subject to
                    respective party terms and conditions. CLOUDKITCH takes no responsibility for such offers.
                  </p>
                </li>
                <li>
                  <p>
                    CLOUDKITCH neither make any representation or warranty as to specifics (such as quality, value,
                    saleability, etc.) of the products or services proposed to be sold or offered to be sold or
                    purchased on the Platform nor does implicitly or explicitly support or endorse the sale or purchase
                    of any products or services on the Platform. CLOUDKITCH accepts no liability for any errors or
                    omissions, whether on behalf of itself or third parties.
                  </p>
                </li>
                <li>
                  <p>
                    CLOUDKITCH is not responsible for any non-performance or breach of any contract entered into between
                    Buyers and Merchants on the Platform. CLOUDKITCH cannot and does not guarantee that the concerned
                    Buyers and/or Merchants will perform any transaction concluded on the Platform. CLOUDKITCH is not
                    responsible for unsatisfactory or non-performance of services or damages or delays as a result of
                    products which are out of stock, unavailable or back ordered.
                  </p>
                </li>
                <li>
                  <p>
                    CLOUDKITCH is operating an online marketplace and assumes the role of facilitator, and does not at
                    any point of time during any transaction between Buyer and Merchant on the Platform come into or
                    take possession of any of the products or services offered by Merchant. At no time shall CLOUDKITCH
                    hold any right, title or interest over the products nor shall CLOUDKITCH have any obligations or
                    liabilities in respect of such contract entered into between Buyer and Merchant.
                  </p>
                </li>
                <li>
                  <p>
                    CLOUDKITCH is only providing a platform for communication and it is agreed that the contract for
                    sale of any of the products or services shall be a strictly bipartite contract between the Merchant
                    and the Buyer. In case of complaints from the Buyer pertaining to food efficacy, quality, or any
                    other such issues, CLOUDKITCH shall notify the same to Merchant and shall also redirect the Buyer to
                    the consumer call center of the Merchant where applicable. The Merchant shall be liable for
                    redressing Buyer complaints. In the event you raise any complaint on any Merchant accessed using our
                    Platform, we shall assist you to the best of our abilities by providing relevant information to
                    you,such as details of the Merchant and the specific Order to which the complaint relates, to enable
                    satisfactory resolution of the complaint.
                  </p>
                </li>
                <li>
                  <p>
                    Please note that there could be risks in dealing with underage persons or people acting under false
                    pretence.
                  </p>
                </li>
              </ul>
            </div>
          </b-card-text>
      </div>
    </main>

    <loginRegModal/>
    <footerLayout/>
    <!-- footer layout -->
  </div>
</template>
<script>
import loginRegModal from "../popUpModals/loginReg";
import footerLayout from "../../layouts/footerLayout";
import Drawer from "vue-simple-drawer"


import Vue from 'vue';

export default {
  data() {
    return {
      policyType: '',
      openMenuDrawer: false,
    }
  },

  components: {
    footerLayout,
    loginRegModal,
    Drawer
  },
  mounted() {
    if (this.$route.params.policy) {
      this.policyType = this.$route.params.policy;
    }
    this.getUserData();

  },
  methods: {

    userRedirection(routerName) {
      if (this.userName != '') {
        if (routerName != '/checkOut') {
          window.location.href = routerName;
          return;
        }
        if (this.cartItemsDetailsHead.length > 0 && routerName == '/checkOut') {
          this.openMenuDrawer = false;
          // this.$router.push(routerName);
          window.location.href = routerName;
        } else {
          alert('No items in cart');
        }
      } else {
        this.openMenuDrawer = !this.openMenuDrawer;
        this.$bvModal.show("modal-login");
      }
    },

    getUserData() {
      this.axios.get('/getUserDeatils')
          .then((response) => {
            let status = response.status;
            if (status == 200 && response.data.status == 200) {
              if (response.data.userData.userName) {
                this.userName = response.data.userData.userName;
                this.corporateLogo = response.data.userData.corporateLogo;
              } else {
                this.userName = '';
              }
            }
          }).catch((error) => {
        console.log(error.response.data.message);
      });
    },
    toggleMenuDrawer() {
      this.openMenuDrawer = !this.openMenuDrawer
    },
    openLoginModal() {
      this.openMenuDrawer = !this.openMenuDrawer;
      this.$bvModal.show("modal-login");

    },
    logout() {
      this.$confirm("Are you sure you want to logout?", "Logout", "")
          .then(() => {
            localStorage.clear();
            Vue.prototype.$userData = '';
            Vue.prototype.$placesAddress = '';
            window.location.href = '/';
          });
    },

    pushPolicy(policyTypeTab) {
      this.$router.push('/policies/' + policyTypeTab);
    }
  }
}
</script>
<style scoped src="../../templateAssests/css/listing.css"></style>
<style scoped src="../../templateAssests/css/detail-page.css"></style>
<style>
.mainLogoImg {
  object-fit: cover;
  /* margin-left: 150px; */
}

.tabs {
  width: 100%;
}

.setionTitle {
  font-size: 30px;
  margin: 0 0 50px 0;
  color: #A4827D;
}

body {
  background: #fff !important;
}

.nav-pills {
  margin-top: 20px !important;

}

.tab-content {
  margin: 30px 0px !important;
  border-left: 1px solid #f1f1f1

}

.card-text {
  color: #A4827D;
}

.policyHead {
  margin: 35px 0;
  margin-bottom: 10px;
  color: #A4827D;
  font-size: 24px;
}

ul, li {
  text-decoration: none;
  padding-left: 0px;
}

li h4,
h4 {
  color: #A4827D;
  margin-top: 20px;
  margin-bottom: 5px;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  color: #000;
  background-color: #ffc60c;
}

.section-services p {
  margin-bottom: 0px;
  line-height: 30px;
  font-size: 14px;
}

.section-services a {
  color: #F3766A;
}

.custTable {
  border: 1px solid #f1f1f1;
  margin-top: 30px;
  margin-bottom: 30px;
}

.custTable tr th {
  background-color: #f1f1f1;
  text-align: left;
}

table, tr, td, th {
  border-spacing: 0;
  padding: 0;
  margin: 0;
  vertical-align: top;
}

.custTable tr th, .custTable tr td {
  padding: 15px;
  border: 1px solid #f1f1f1;
}

.process-table {
  width: 100%;
}

#logo a {
  color: #000;
}

#logo a:hover, .logo a:focus {
  color: #F3766A;
}

/* .tabsPostion{
    border-right: 1px solid #f1f1f1;
    position: sticky;
    top: 90px;
    height: 100%;
} */
header {
  position: sticky !important;
}

.rightDiv a {
  color: #000;
}

.rightDiv a:hover, .rightDiv a:focus {
  color: #F3766A;
}

.rightDiv a i {
  margin-left: 5px;
  margin-right: 3px;
}

.home {
  font-family: 'GothamMedium' !important;
  font-size: 16px;
  color: #212121;
}

a.phneNo, a.email {
  font-size: 14px;
  color: #212121;
}

@media (min-width: 575px) {
  .tabsPostion {
    /* border-right: 1px solid #f1f1f1; */
    position: sticky;
    top: 90px;
    height: 100%;
    padding-left: 20px;
  }
}

.userPlaceImage {
  object-fit: contain;
  border-radius: 25px;
}

.loginReg {
  font-size: 18px;
  color: #F3766A;
}

.head_section {
  margin-bottom: 20px;
}

/* .navigation_ul
{
	list-style-type: none;
	padding: 0;
} */
.navigation_ul li {
  padding: 12px 0;
  font-size: 14px;
}

.navigation_ul a li {
  color: #777;
}

.helpHead {
  font-size: 16px;
  color: #777;
}
</style>